module.exports = __webpack_public_path__ + "assets/ic_sort_projects.f2d30a1f.svg";